// lightweight parsley alternative
// only checks required attribute
// written by dev-rke

export default function () {
    // some validation for external forms
    const $parsley = $('[data-parsley-validate]');

    if (!$parsley.length) {
        return;
    }

    const errorListClass = '.parsley-errors-list';

    function addErrorClass($element, $form) {
        $element.addClass('parsley-error');
        if ($element.next(errorListClass).length) {
            return;
        }
        const error = `<ul class="parsley-errors-list filled">
                <li class="parsley-custom-error-message">
                    ${$form.data('parsley-error-message')}
                </li>
            </ul>`;
        $element.after(error);
    }

    function removeErrorClass($element) {
        $element.removeClass('parsley-error');
        $element.next(errorListClass).remove();
    }

    $parsley.each((i, form) => {
        const $form = $(form);
        const $elements = $form.find('[required]');
        // we need to disable native html5 form validation to validate the form manually
        $form.attr('novalidate', true);

        $form.on('submit', (e) => {
            $.each($elements, function eachHandler() {
                const $element = $(this);
                if (!$element.val().length) {
                    e.preventDefault();
                    addErrorClass($element, $form);
                } else {
                    removeErrorClass($element);
                }
            });
        });

        $form.on('change input', $elements, (e) => {
            const $element = $(e.target);
            if (!$element.val().length) {
                addErrorClass($element);
            } else {
                removeErrorClass($element);
            }
        });
    });
}
